import React from "react";
import Navbar from "../cummon/Navbar";

function HomeMenu() {
  return (
    <div>
      <Navbar />
    </div>
  );
}

export default HomeMenu;
